import { NBSP } from '../../../../../constants/symbols';

export const PAYMENT_PENDING_TITLE = 'Ожидаем оплаты';
export const PAYMENT_PENDING_MESSAGE = `Иногда обработка платежей занимает некоторое время. Пожалуйста, не${NBSP}уходите с этой страницы, пока не убедитесь, что платёж прошёл успешно.`;
